import Cookies from 'js-cookie';
import serverVars from 'server-vars';

import { LANDING_SESSION_COOKIE } from '../../constants/cookieConstants';

export function clientSetLandingSessionCookie() {
    const isServerVar = serverVars.get('cdnQueryParams.ls') === 'true';
    const isCookie = Cookies.get(LANDING_SESSION_COOKIE);

    if (isServerVar && !isCookie) {
        Cookies.set(LANDING_SESSION_COOKIE, true, { expires: '' });
    }
}
